
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 59.53 51.59"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M56.61 0H2.92A2.92 2.92 0 000 2.92v45.75a2.92 2.92 0 002.92 2.92h53.69a2.92 2.92 0 002.92-2.92V2.92A2.92 2.92 0 0056.61 0zm-19 15.78l5.08-7.24A1.26 1.26 0 0143.7 8h5.75a1.27 1.27 0 011 2l-8.32 11.54a.39.39 0 01-.64 0l-3.91-5.29a.41.41 0 01-.01-.47zM11.91 8a4 4 0 11-4 4 4 4 0 014-4zm4 34.36a1.28 1.28 0 01-1.28 1.28H9.21a1.28 1.28 0 01-1.27-1.28v-23A1.27 1.27 0 019.21 18h5.39a1.27 1.27 0 011.28 1.27zm9.68 1.28h-6.3a1.28 1.28 0 01-1-2L30 25.5 18.86 10a1.28 1.28 0 011-2h6.23a1.28 1.28 0 011 .54L39.32 25a.39.39 0 010 .47l-12.71 17.6a1.27 1.27 0 01-1.05.56zm24.75 0H44a1.29 1.29 0 01-1.05-.55l-5.53-8a.39.39 0 010-.46l4.17-5.75a.39.39 0 01.64 0l9.16 12.7a1.28 1.28 0 01-1.08 2.05z","fill":"#1d1d1b","data-name":"Vrstva 2"}})])
          )
        }
      }
    